<!-- displaying error message -->
<div *ngIf="showErrors" class="container-box mobilebox" id="error-main-container">
    <div class="alert valign-children-middle mar-top-20 alert-container1" id="alert-container">
        <div class="alert-error" aria-label="Alert." id="alert-error-container">
            <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div id="error-message-container">
            <h2>Error</h2>
            <p>This Apple Organization ID is already associated with this Foundation Account. Please provide another
                Organization ID.</p>
        </div>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div>
</div>
<!-- <div *ngIf="setupError" class="alert valign-children-middle error-container" id="alert-container">
    <div class="alert-error" role="img">
        <i class="icon-badgealert" aria-label="alert"></i>
    </div>
    <div>{{errorMessage}}</div>
    </div> -->
<!-- displaying error message -->
<div *ngIf="failuremessage" class="container-box" id="error-container">
    <div class="alert valign-children-middle mar-top-20" id="alert-container">
        <div class="alert-error" aria-label="Alert." id="alert-error-container">
            <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div id="error-message-container">
            <!-- <h2 tabindex="-1" id="error-heading">Error</h2> -->
            <p id="error-message">Error</p>
            <p>Organization ID update failed. Check entry and retry. If issue continues, contact support at 866.563.4703
                .</p>
        </div>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div>
</div>
<!--  
 <div  *ngIf="failuremessage" class="container-box" id="error-container">
    <div class="alert valign-children-middle mar-top-20" id="alert-container">
        <div class="alert-error" aria-label="Alert." id="alert-error-container">
            <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div id="error-message-container">
            <h2>Error</h2>
            <p>Organization ID update failed.   Check entry and retry.   If issue continues, contact support at 866.563.4703 .</p>
         </div>
    </div>
  </div> -->
<!-- displaying success message -->
<div *ngIf="formSuccess" id="success-main-container">
    <div class="container-box" id="success-container">
        <div class="alert valign-children-middle" id="alert-success-container">
            <div class="alert-success">
                <i class="icon-approval" aria-hidden="true"></i>
            </div>
            <div id="success-message-container">
                <h2>Success</h2>
                <p>Organization ID updated successfully.</p>
            </div>
            <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
        </div>
    </div>
</div>
<div class="main-div">
    <div *ngIf="setupError" class="container-box mobilebox" id="error-container" style="padding-left: 0px;
    padding-right: 0px;">
        <div class="alert valign-children-middle mar-top-20" id="alert-container">
            <div class="alert-error" aria-label="Alert." id="alert-error-container">
                <i class="icon-badgealert" aria-hidden="true"></i>
            </div>
            <div id="error-message-container">
                <!-- <h2 tabindex="-1" id="error-heading">Error</h2> -->
                <p id="error-message">Error</p>
                <p>{{errorMessage}}</p>
            </div>
            <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
        </div>
    </div>
    <div class="content-section">
        <!-- <h2><b>{{manageAccounts.heading}}</b></h2>
        <br> -->
        <h3>{{manageAccounts.subHeading}}</h3> <br>
        <p><strong>{{manageAccounts.fan}}</strong>{{this.fan}}</p>
        <p class="content">{{manageAccounts.content1}}<strong>{{manageAccounts.content2}}</strong>{{manageAccounts.content3}}</p>
        <div><strong>{{manageAccounts.verify}}</strong> <span class="bluecontent">
                <strong> <a href="https://www.apple.com/business/it/" target="_blank">{{manageAccounts.abm}}</a></strong>
            </span>
            <div class="tooltip-input inline-labels">
                <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp"
                (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
                <div role="tooltip" class="helper-text" id="inputhelp">
                    {{manageAccounts.tooltip}}</div>
            </div>
        </div>
    </div>
    <br>
    <!-- <br> -->
    <form [formGroup]="form" (ngSubmit)="continueToNext()">

        <div class="form-group">
            <p><strong> New Apple Organization ID</strong></p>
            <input formControlName="appleorgid" id="appleorgid" type="text" placeholder="Enter an Apple Organization ID"
                maxlength="32" pattern="^[0-9A-Za-z]{1,32}$" class="form-control field">
            <div *ngIf="f.appleorgid.touched && f.appleorgid.invalid" class="validation-error">
                <div *ngIf="f.appleorgid.errors.required">Apple Org ID is required.</div>
                <div *ngIf="f.appleorgid.errors?.pattern">
                    Apple Org ID is not valid.
                </div>
            </div>
        </div>

        <div class="form-group">
            <p><strong>Confirm New Apple Organization ID</strong></p>
            <input formControlName="confirmappleorgid" id="confirmappleorgid" type="text" pattern="^[0-9A-Za-z]{1,32}$"
                maxlength="32" placeholder="Re-enter Apple Organization ID" class="form-control field">
            <div *ngIf="f.confirmappleorgid.touched && f.confirmappleorgid.invalid" class="validation-error">
                <div *ngIf="f.confirmappleorgid.errors.required">Confirm Apple Org ID is required.</div>
                <div *ngIf="f.confirmappleorgid.errors?.pattern">
                    Confirm Apple Org ID is not valid.
                </div>
                <div *ngIf="f.confirmappleorgid.errors.confirmedValidator">
                    Apple Organization IDs do not match.</div>
            </div>
        </div>
        <br>
        <p>{{manageAccounts.explain1}}</p>
        <p>{{manageAccounts.explain2}}</p>
        <br>
        <!-- <p>
            <label class="checkbox">
                <input type="checkbox" (change)="moveDevices = !moveDevices">
                <i class="skin"></i>
                <span>{{manageAccounts.checkbox}} </span>
            </label>
        </p>
        <div class="acknowledgement-section">
            <i class="icon-alert" role="img" aria-label="Alert"></i><strong>{{manageAccounts.alert}}</strong>
        </div>
        <br> -->
        <hr>
        <div class="submit-section col-sm-12 col-md-12 text-right ">
            <button class="btn btn-secondary pull-right" id="orgIdChange" #submitButton
                [disabled]="!form.valid || errorMessage || setupError  ">{{manageAccounts.save}}</button>
            <a id="cancel-link" href="/businessconsole/manageInventory"
                class="btn btn-link bt-block btn-cancel">{{manageAccounts.cancel}}</a>
        </div>
        <br>
        <!-- <button class="btn btn-primary" type="submit" [disabled]="!form.valid">Submit</button> -->
    </form>
    <!-- <div class="data-section">
        <p><b>Apple Organization ID</b></p>
        <p class="field">
            <input class="textbox" type="text" placeholder="Enter an Apple Organization ID" >
        </p>
        <br/>
        <p><b>Confirm Apple Organization ID</b></p>
        <p class="field">
            <input class="textbox" type="text" placeholder="Re-enter Apple Organization ID" >
        </p>
    </div>
    <br>
    <p>{{manageAccounts.explain1}}</p>
    <p>{{manageAccounts.explain2}}</p>
    <br>
    <p>
        <label class="checkbox">
            <input type="checkbox" (change)="moveDevices = !moveDevices">
            <i class="skin"></i>
            <span>{{manageAccounts.checkbox}} </span>
        </label>
    </p>
    <div class="acknowledgement-section">
        <i class="icon-alert" role="img" aria-label="Alert"></i><b>{{manageAccounts.alert}}</b>
    </div> 
    <br>
    <hr>
    <div class="submit-section col-sm-12 col-md-12 text-right ">
        <button class="btn btn-secondary pull-right" id="orgIdChange" [disabled]="isDisabled"
            (click)="continueToNext()">{{manageAccounts.save}}</button>
        <a id="cancel-link" href="/businessconsole/manageInventory"
            class="btn btn-link bt-block btn-cancel">{{manageAccounts.cancel}}</a>
    </div>
    <br> -->
</div>